const mutationTypes = {
  SET_AUDITS: 'SET_AUDITS',
  SET_SPECIFIC_AUDIT: 'SET_SPECIFIC_AUDIT',
  SET_ANSWERS: 'SET_ANSWERS',
  SET_PENDING_ANSWERS: 'SET_PENDING_ANSWERS',
  UPDATE_PENDING_ANSWER: 'UPDATE_PENDING_ANSWER',
  // Deficiencies
  SET_CURRENT_SET_DEFICIENCIES: 'SET_CURRENT_SET_DEFICIENCIES',
  SET_PREPARED_DEFICIENCIES: 'SET_PREPARED_DEFICIENCIES',
  UPDATE_PREPARED_DEFICIENCY: 'UPDATE_PREPARED_DEFICIENCY',
  UPDATE_DEFICIENCY_RESULT: 'UPDATE_DEFICIENCY_RESULT',
}

const actionTypes = {
  FETCH_AUDITS: 'FETCH_AUDITS',
  FETCH_AUDIT: 'FETCH_AUDIT',
  CREATE_AUDIT: 'CREATE_AUDIT',
  FETCH_ANSWERS: 'FETCH_ANSWERS',
  FETCH_ANSWER: 'FETCH_ANSWER',
  DELETE_ANSWER: 'DELETE_ANSWER',
  PREPARE_PENDING_ANSWERS: 'PREPARE_PENDING_ANSWERS',
  SAVE_PENDING_ANSWERS: 'SAVE_PENDING_ANSWERS',
  // Deficiencies
  FETCH_CURRENT_SET_DEFICIENCIES: 'FETCH_CURRENT_SET_DEFICIENCIES',
  FETCH_PREPARED_DEFICIENCIES: 'FETCH_PREPARED_DEFICIENCIES',
  CREATE_PREPARED_DEFICIENCY: 'CREATE_PREPARED_DEFICIENCY',
  UPDATE_PREPARED_DEFICIENCY: 'UPDATE_PREPARED_DEFICIENCY',
  DELETE_PREPARED_DEFICIENCY: 'DELETE_PREPARED_DEFICIENCY',
  SAVE_PREPARED_DEFICIENCY_PROOF: 'SAVE_PREPARED_DEFICIENCY_PROOF',
  SAVE_DEFICIENCY_RESULT: 'SAVE_DEFICIENCY_RESULT',
  SAVE_DEFICIENCY_RESULT_PROOF: 'SAVE_DEFICIENCY_RESULT_PROOF',
}

const getTypes = {
  GET_ANSWER: 'GET_ANSWER',
  GET_PENDING_ANSWER: 'GET_PENDING_ANSWER',
}

export { mutationTypes, actionTypes, getTypes }



// WEBPACK FOOTER //
// ./src/store/modules/AuditsTypes.js